// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"326":"b1940699","384":"9ac30738","578":"a9565f00","833":"77646d55","872":"443f1e1e","941":"791d0644"}[chunkId] + ".chunk.css";
};